import { Button, Card, Flex, Typography } from "antd";
import Chart from "react-apexcharts";
import React, { useState } from "react";

import rightArrow from "../../../../assets/icons/arrow-circle-right.svg";
import leftArrow from "../../../../assets/icons/arrow-circle-left.svg";

import "./styles.css";

export default function TopTreatmentsByPlanType() {
  const [selectedPaginationPoint, setSelectedPaginationPoint] = useState(3);

  return (
    <Card style={{ minWidth: 351, height: 350 }}>
      <Flex vertical>
        <Typography.Title level={4} style={{ marginBottom: 0 }}>
          Top Treatments by Plan Type
        </Typography.Title>

        <Flex gap={10} vertical>
          <TopTreatmentsByPlanTypeChart />

          {/* Chart Pagination */}
          <Flex align="center" justify="space-between">
            <Button
              onClick={() => setSelectedPaginationPoint((index) => index - 1)}
              style={{ width: 30, border: "none" }}
              disabled={selectedPaginationPoint <= 1}
            >
              <img src={leftArrow} alt="left-arrow" style={{ width: 28 }} />
            </Button>

            <Flex gap={3}>
              {Array.from({ length: 5 }).map((item, index) => (
                <div
                  className={`chart-pagination ${selectedPaginationPoint === index + 1 && "chart-pagination-active"}`}
                  onClick={() => setSelectedPaginationPoint(index + 1)}
                ></div>
              ))}
            </Flex>

            <Button
              onClick={() => setSelectedPaginationPoint((index) => index + 1)}
              style={{ width: 30, border: "none" }}
              disabled={selectedPaginationPoint >= 5}
            >
              <img src={rightArrow} alt="right-arrow" style={{ width: 28, cursor: "pointer" }} />
            </Button>
          </Flex>

          {/* Custom Legend */}
          <Flex align="center" justify="space-between" style={{ width: "100%" }}>
            <Flex gap={5} align="center">
              <div style={{ width: 10, height: 10, backgroundColor: "#E0DDF7", borderRadius: 100 }}></div>
              <Typography.Text style={{ fontSize: 12, marginBottom: 0 }}>Insurance</Typography.Text>
            </Flex>
            <Flex gap={5} align="center">
              <div style={{ width: 10, height: 10, backgroundColor: "#AD9EE7", borderRadius: 100 }}></div>
              <Typography.Text style={{ fontSize: 12, marginBottom: 0 }}>Single Payment</Typography.Text>
            </Flex>
            <Flex gap={5} align="center">
              <div style={{ width: 10, height: 10, backgroundColor: "#6B43B5", borderRadius: 100 }}></div>
              <Typography.Text style={{ fontSize: 12, marginBottom: 0 }}>Recurring</Typography.Text>
            </Flex>
          </Flex>
        </Flex>
      </Flex>
    </Card>
  );
}

const TopTreatmentsByPlanTypeChart = () => {
  const series = [
    {
      name: "Insurance",
      data: [75, 70, 65, 90, 80],
    },
    {
      name: "Single Payment",
      data: [55, 75, 85, 70, 65],
    },
    {
      name: "Recurring",
      data: [45, 90, 95, 60, 85],
    },
  ];

  const options = {
    chart: {
      type: "bar",
      height: 220,
      toolbar: { show: false },
      zoom: { enabled: false },
      parentHeightOffset: 0,
      spacingTop: 0,
      spacingBottom: 0,
      margin: 0,
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: "60%",
        borderRadius: 6,
        endingShape: "rounded",
      },
    },
    dataLabels: { enabled: false },
    stroke: {
      show: true,
      width: 2,
      colors: ["transparent"],
    },
    colors: ["#E0DDF7", "#AD9EE7", "#6B43B5"], // Light → Dark Purple
    xaxis: {
      categories: ["CRW", "WRT", "RSD", "GER", "RSD"],
      labels: {
        style: {
          fontSize: 12,
          fontWeight: 600,
          colors: "#979797",
        },
      },
      axisBorder: { show: false },
      axisTicks: { show: false },
    },
    yaxis: {
      min: 0,
      max: 100,
      tickAmount: 5,
      labels: {
        formatter: (val) => val + "%",
        style: {
          fontSize: 12,
          colors: "#979797",
        },
      },
    },
    grid: {
      show: false,
      // borderColor: "#f0f0f0",
      // strokeDashArray: 0,
      // xaxis: { lines: { show: false } },
      // yaxis: { lines: { show: true } },
      // padding: { top: 0, right: 0, bottom: 0, left: 0 },
    },
    legend: {
      show: false,
      // position: "bottom",
      // horizontalAlign: "center",
      // offsetY: 8,
      // markers: {
      //   width: 12,
      //   height: 12,
      //   radius: 12,
      // },
      // containerMargin: { left: 0, right: 0 },
      // width: "100%",
      // floating: false,
      // itemMargin: { horizontal: 20, vertical: 0 }, // more space between items
      // labels: { colors: "#595959" },
      // fontSize: "13px",
      itemMargin: { horizontal: 12 },
      labels: { colors: "#979797" },
      fontSize: 12,
    },
    tooltip: {
      shared: true,
      intersect: false,
      y: { formatter: (val) => val + "%" },
    },
    states: {
      hover: { filter: { type: "none" } },
      active: { filter: { type: "none" } },
    },
  };

  return <Chart options={options} series={series} type="bar" height={210} />;
};
